import React from 'react'
import { hooks } from '@front/volcanion'

const withContainer = Component => ({ ...props }) => {
  const [step] = hooks.useFormState('step')

  const mergedProps = {
    step
  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer
